import React from 'react'
import TimeDifference from '../../../common/TimeDifference';
import { Tooltip } from 'react-tooltip';

function ContactList({users, handleUserSelect,selectedUser,lastPage,handleLoadMore}) {

  function formatPhoneNumber(phoneNumberString) {
    const cleaned = ('' + phoneNumberString).replace(/\D/g, '');
    const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      return '(' + match[1] + ') ' + match[2] + '-' + match[3];
    }
    return null;
  }
  
  function handleTrim (str, len) {
    return str.length > len ? str.substring(0, len) + '...' : str;
  }
  
  return (
    <div className='' style={{height:"70vh",overflowY:"scroll"}}>
        <ul className='list-group list-group-flush rounded mt-4'>
            {users && users.map((user) => (
                <li 
                    className={`list-group-item mb-2 pb-2 list-group-item-action d-flex justify-content-between align-items-start ${selectedUser && selectedUser === user.customerNumber ? 'bg-secondary ' : ''}` }
                    key={user.customerNumber} 
                    onClick={() => handleUserSelect(user.customerNumber)}
                    style={{ cursor: 'pointer' }}
                    data-tooltip-id="fullUserName"
                    data-tooltip-content={user.customerNames}
                    data-tooltip-place="bottom"
                    >
                    <div className="symbol symbol-45px symbol-circle" zn_id="155">
                        <span className="symbol-label bg-light-secondary  fs-6 fw-bolder" zn_id="157">{user.customerNames.trim().charAt(0).toUpperCase()}</span>
                        </div>
                    <div className="ms-2 me-auto flex-fill">
                      <div className="d-flex justify-content-between">
                        <div className="">{user.unreadMessage > 0 ? <span className='fw-bolder'>{handleTrim(user.customerNames,30)}</span> : <span> {handleTrim(user.customerNames,30)} </span>} </div>
                        <span className="badge text-bg-success rounded-pill">{user.unreadMessage >0 ? user.unreadMessage :""}</span>
                      </div>
                    
                       
                       <div className=''>
                       {formatPhoneNumber(user.customerNumber)}
                       </div>
                      
                       
                       <div className='d-flex justify-content-between'>
                         <div className="text-muted">{handleTrim(user.lastMessage,15)}</div>
                         <div className="text-muted"><TimeDifference dateString={user.createdAt} /></div>
                       </div>
                      
                     </div>
                   
                </li>
            ))}
           
           {!lastPage && (
              <button className="btn btn-primary mt-3" onClick={handleLoadMore}>
                  Load More
        </button>
      )}
        </ul>
        <Tooltip id="fullUserName"/>
    </div>
  )
}

export default ContactList